import { useEffect, useState } from "react"
import apiClient from "../../Utils/apiClient"
import {
  Card,
  Typography,
  Row,
  Col,
  Tag,
  Checkbox,
  Button,
  Collapse,
  message,
} from "antd"
import PanelLayout from "../../Layout/PanelLayout"
import { useHeaderContext } from "../../Utils/HeaderContext"
import dayjs from "dayjs"

const { Title, Text } = Typography
const { Panel } = Collapse

const AdminAppRequests = () => {
  const { setTaskId, setRender, render } = useHeaderContext()
  const [refresh, setRefresh] = useState(false)
  const [groupedData, setGroupedData] = useState({})
  const [selectedUsers, setSelectedUsers] = useState([])
  const [selectedApps, setSelectedApps] = useState([])

  useEffect(() => {
    getData()
  }, [refresh, render])

  const getData = async () => {
    const res = await apiClient("request/get-all")
    const allRequests = res?.data || []

    const grouped = allRequests.reduce((acc, request) => {
      const dateKey = dayjs(request.createdAt).format("YYYY-MM-DD")
      const host = request.requestedFrom

      if (!acc[dateKey]) acc[dateKey] = {}
      if (!acc[dateKey][host]) acc[dateKey][host] = []

      acc[dateKey][host].push(request)
      return acc
    }, {})

    setGroupedData(grouped)
  }

  const handleUserCheckbox = (host, checked) => {
    if (checked) {
      setSelectedUsers((prev) => [...prev, host])
    } else {
      setSelectedUsers((prev) => prev.filter((e) => e !== host))
    }
  }

  const handleAppCheckbox = (appId, checked) => {
    if (checked) {
      setSelectedApps((prev) => [...prev, appId])
    } else {
      setSelectedApps((prev) => prev.filter((id) => id !== appId))
    }
  }

  const handleApprove = async () => {
    try {
      const selectedData = []

      selectedUsers.forEach((host) => {
        Object.values(groupedData).forEach((dateGroup) => {
          const userRequests = dateGroup[host] || []
          const userSelectedApps = userRequests.filter((req) =>
            selectedApps.includes(req._id)
          )

          if (userSelectedApps.length > 0) {
            selectedData.push({
              user: host,
              userEmail: userSelectedApps[0]?.requestedEmail,
              // apps: userSelectedApps.map((app) => app.appData),
              apps: userSelectedApps.map((app) => ({
                ...app.appData,
                requestId: app._id,
              })),
            })
          }
        })
      })

      for (const host of selectedData) {
        const appNames = host.apps.map((item) => item.appName).join(",")
        const command = `choco-install:${appNames}`

        const payload = {
          entityType: "installapp",
          appData: [...host.apps],
          command: command,
          name: command,
          hostname: host.user,
          userEmail: host.userEmail,
        }

        console.log("payload ===========>", payload)
        const response = await apiClient(`request/approve`, "POST", payload)
        message.success(`Created Task For ${host.user}`)
        setTaskId(response.taskId)
        setRender((pre) => !pre)
      }
    } catch (err) {
      console.log("err in handleApprove", err)
    }
  }

  const handleReject = async () => {
    try {
      const selectedData = []

      selectedUsers.forEach((host) => {
        Object.values(groupedData).forEach((dateGroup) => {
          const userRequests = dateGroup[host] || []
          const userSelectedApps = userRequests.filter((req) =>
            selectedApps.includes(req._id)
          )

          if (userSelectedApps.length > 0) {
            selectedData.push({
              user: host,
              userEmail: userSelectedApps[0]?.requestedEmail,
              apps: userSelectedApps.map((app) => ({
                ...app.appData,
                requestId: app._id,
              })),
            })
          }
        })
      })

      for (const host of selectedData) {
        const payload = {
          appData: [...host.apps],
          userEmail: host?.userEmail,
          user: host.user,
        }

        const result = await apiClient("request/reject", "POST", payload)
        if (result) {
          setTaskId(result.taskId)
          setRender((pre) => !pre)
          setRefresh((pre) => !pre)
        }
        message.info(result.message)
      }
    } catch (err) {
      console.log("err in handleReject", err)
    }
  }

  const handleInstall = async (item) => {
    try {
      const command = `choco-install:${item?.appData?.appName}`
      const appData = { ...item.appData, requestId: item?._id }
      const payload = {
        entityType: "installapp",
        appData: [appData],
        command: command,
        name: command,
        hostname: item?.requestedFrom,
        userEmail: item?.requestedEmail,
      }
      console.log("payload ===========>", payload)

      const response = await apiClient(`request/approve`, "POST", payload)
      message.info(response.message)
      setTaskId(response.taskId)
      setRender((pre) => !pre)
    } catch (err) {
      console.log("err on Handle Install", err)
    }
  }
  const handleUnInstall = async (item) => {
    try {
      const command = `choco-uninstall:${item?.appData?.appName}`
      const appData = { ...item.appData, requestId: item?._id }

      const payload = {
        entityType: "uninstallapp",
        appData: [appData],
        command: command,
        name: command,
        hostname: item?.requestedFrom,
        userEmail: item?.requestedEmail,
      }

      const response = await apiClient(`request/uninstall`, "POST", payload)
      message.info(response.message)
      setTaskId(response.taskId)
      setRender((pre) => !pre)
    } catch (err) {
      console.log("err on Handle Install", err)
    }
  }

  return (
    <PanelLayout
      title="App Requests"
      subtitle="Approve or reject software installation requests from users."
      actions={
        <div className="d-flex align-items-center gap-2">
          <Button size="small" onClick={handleApprove}>
            Approve
          </Button>
          <Button size="small" danger onClick={handleReject}>
            Reject
          </Button>
        </div>
      }
    >
        <Collapse accordion>
          {/* {Object.entries(groupedData).map(([date, users]) => (
            <Panel
              header={`📅 ${dayjs(date).format("DD MMM YYYY")}`}
              key={date}
            >
              <Collapse accordion>
                {Object.entries(users).map(([host, requests]) => (
                  <Panel
                    header={
                      <div className="d-flex justify-content-between align-items-center">
                        <span>👤 {host}</span>
                        <Checkbox
                          onChange={(e) =>
                            handleUserCheckbox(host, e.target.checked)
                          }
                          style={{ marginLeft: 8 }}
                        >
                          Select User
                        </Checkbox>
                      </div>
                    }
                    key={`${date}-${host}`}
                  >
                    <Row gutter={[16, 16]}>
                      {requests.map((item) => (
                        <Col key={item._id} xs={24} sm={12} md={8} lg={6}>
                          <Card hoverable bordered>
                            <div className="d-flex align-items-center justify-content-between">
                              <Title level={5} style={{ marginBottom: 8 }}>
                                {item.appData?.title}
                              </Title>
                              {item.status !== "Rejected" && (
                                <Checkbox
                                  onChange={(e) =>
                                    handleAppCheckbox(
                                      item._id,
                                      e.target.checked
                                    )
                                  }
                                />
                              )}
                            </div>
                            <Text type="secondary">
                              Version: {item.appData?.version}
                            </Text>
                            <div style={{ marginTop: 10 }}>
                              <Tag
                                color={
                                  item.status === "pending"
                                    ? "orange"
                                    : item.status === "Completed"
                                    ? "green"
                                    : "red"
                                }
                              >
                                {item.status?.toUpperCase()}
                              </Tag>
                            </div>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </Panel>
                ))}
              </Collapse>
            </Panel>
          ))} */}
          {Object.entries(groupedData)
            .sort(([a], [b]) => dayjs(b).diff(dayjs(a)))
            .map(([date, users]) => (
              <Panel
                header={`📅 ${dayjs(date).format("DD MMM YYYY")}`}
                key={date}
              >
                <Collapse accordion>
                  {Object.entries(users).map(([host, requests]) => (
                    <Panel
                      header={
                        <div className="d-flex justify-content-between align-items-center">
                          <span>👤 {host}</span>
                          <Checkbox
                            onChange={(e) =>
                              handleUserCheckbox(host, e.target.checked)
                            }
                            style={{ marginLeft: 8 }}
                          >
                            Select User
                          </Checkbox>
                        </div>
                      }
                      key={`${date}-${host}`}
                    >
                      <Row gutter={[16, 16]}>
                        {requests.map((item) => (
                          <Col key={item._id} xs={24} sm={12} md={8} lg={6}>
                            <Card hoverable bordered>
                              <div className="d-flex align-items-center justify-content-between">
                                <Title level={5} style={{ marginBottom: 8 }}>
                                  {item.appData?.title}
                                </Title>

                                {item.status === "pending" && (
                                  <Checkbox
                                    onChange={(e) =>
                                      handleAppCheckbox(
                                        item._id,
                                        e.target.checked
                                      )
                                    }
                                  />
                                )}
                              </div>
                              <Text type="secondary">
                                Version: {item.appData?.version}
                              </Text>
                              <div
                                className="d-flex align-items-center justify-content-between"
                                style={{ marginTop: 10 }}
                              >
                                <Tag
                                  color={
                                    item.status === "pending"
                                      ? "orange"
                                      : item.status === "Completed"
                                      ? "green"
                                      : "red"
                                  }
                                >
                                  {item.status?.toUpperCase()}
                                </Tag>
                                {item.status === "Completed" ? (
                                  <Tag
                                    onClick={() => handleUnInstall(item)}
                                    color={"red"}
                                  >
                                    Uninstall
                                  </Tag>
                                ) : (
                                  <Tag
                                    color={"green"}
                                    onClick={() => handleInstall(item)}
                                  >
                                    Install
                                  </Tag>
                                )}
                              </div>
                            </Card>
                          </Col>
                        ))}
                      </Row>
                    </Panel>
                  ))}
                </Collapse>
              </Panel>
            ))}
        </Collapse>
    </PanelLayout>
  )
}

export default AdminAppRequests
